export class Choice {
    public value: string;
    public valueDisplayString: string;
    public text: string;

    constructor(value: string, text: string, valueDisplayString?: string) {
        this.value = value;
        this.valueDisplayString = valueDisplayString || value;
        this.text = text;
    }
}
